module.exports = __webpack_public_path__ + "img/process6.11666265.png";